App.factory('CustomFormBuilder', [
  '$rootScope', '$stateParams', '$state', 'Form', 'FormResponse', 'FormResponseCheckExisting',
  'datesInTimezone', '$q', 'browser', '$window', '$timeout', '$api', 'FeatureFlag', function (
  $rootScope, $stateParams, $state, Form, FormResponse, FormResponseCheckExisting,
  datesInTimezone, $q, browser, $window, $timeout, $api) {

    this.setupForm = (internal_scope) => {
      if (!$rootScope.institution) {
        $rootScope.institution = internal_scope.form.institution
      }

      if (internal_scope.form.parent && internal_scope.form.parent.tz) {
        $rootScope.timezone = internal_scope.form.parent.tz
      } else if ($rootScope.institution) {
        $rootScope.timezone = $rootScope.institution.tz
      }

      internal_scope.isFilteredForm = internal_scope.filterType

      filtered_sections = _.filter(internal_scope.form.sections, section => { return this.filterSections(internal_scope, section) })
      internal_scope.form_tabs = _.uniq(_.map(filtered_sections, (section, index) => {
        return { 'name': section.form_section,
                 'index': index,
                 'caption': (section.form_section_caption || section.form_section),
                 'group_section': section.group_section }
      }))

      internal_scope.form_group_tabs = _.uniq(_.map(internal_scope.form.sections, (section, index) => {
        return section.group_section
      }))

      this.initialize(internal_scope)
      this.setTabs(internal_scope)
      this.toggleChildFields(internal_scope)
      this.focusOnFirstField(internal_scope)
    }

    this.filterSections = (internal_scope, section) => {
      // there is no filter, so return all sections
      if (!internal_scope.isFilteredForm) {
        return true
      }

      // Filter by Group of Sections
      if (internal_scope.filterType == 'group') {

        // Force patient info to partial forms
        no_patient_information_group_chosen = internal_scope.filterId != 'patient_information'
        is_the_patient_information_group = section.group_section == 'patient_information'
        if ( no_patient_information_group_chosen && is_the_patient_information_group ) {
          return true
        }

        return (internal_scope.filterId == section.group_section)
      }

      // Filter by Sections
      if (internal_scope.filterType == 'section') {

        // Force patient info to partial forms
        is_pediatric_form = internal_scope.form.form_type == 'pediatric'
        no_child_information_section_chosen = internal_scope.filterId != 'child_information'
        is_the_child_information_section = section.form_section == 'child_information'

        if ( is_pediatric_form && no_child_information_section_chosen && is_the_child_information_section) {
          return true
        }

        is_patient_or_custom_form = ['patient', 'custom'].includes(internal_scope.form.form_type)
        no_personal_info_section_chosen = internal_scope.filterId != 'personal_info'
        is_the_personal_info_section = section.form_section == 'personal_info'

        if ( is_patient_or_custom_form && no_personal_info_section_chosen && is_the_personal_info_section) {
          return true
        }

        if (internal_scope.form.documents.length > 0 && section.form_section == 'custom') {
          return true
        }

        return (internal_scope.filterId == section.form_section)
      }
    }

    this.formGet = (internal_scope) => {
      internal_scope.form_loading = true
      internal_scope.form = Form.$find(internal_scope.form_id, {
        remember_token: internal_scope.remember_token,
      })
      internal_scope.form.$finally(() => {
        if (internal_scope.form.$response.data.code) {
          internal_scope.errors = []
          internal_scope.user_id = internal_scope.form.$response.data.data.user_id
          internal_scope.form = internal_scope.form.$response.data.data.form
          this.setupForm(internal_scope)
        } else {
          internal_scope.hide_buttons = true
          this.setErrors(internal_scope, internal_scope.form)
        }
        internal_scope.form_loading = false
      })
    }

    this.setTabs = (internal_scope) => {
      // Custom
      other_fields = _.filter(internal_scope.form.fields, (field) => {
        return field.form_section == 'custom'
      })

      if (other_fields.length == 0 && internal_scope.form.documents.length == 0) {
        internal_scope.form_tabs = _.filter(internal_scope.form_tabs, (tab) => tab.name != 'custom')
      }

      internal_scope.form_groups = {}
      _.each(internal_scope.form.sections, section => {
        internal_scope.form_groups[section.group_section] = { caption: (section.group_section_caption || section.group_section),
        tabs: _.filter(internal_scope.form_tabs, f_section => { return f_section.group_section == section.group_section }) }
      })
    }

    this.initialize = (internal_scope) => {
      internal_scope.boolean_options = [
        { 'label': 'Yes', 'value': true },
        { 'label': 'No', 'value': false }
      ]
      internal_scope.activePill = 0
      this.setCurrentTab(internal_scope)
      internal_scope.form_submit = {}
      this.autoFillPatientsData(internal_scope)

      // set form date to today
      common_form_date = _.find(
        internal_scope.form.fields,
        (field) => field.form_type == 'common' && field.label == 'Date'
      )
      if (common_form_date) {
        if (internal_scope.is_mobile) {
          new_date = new Date()
        } else { // text input
          new_date = moment().tz($rootScope.timezone)
          new_date = this.dateFormat(new_date, 'MM/DD/YYYY')
        }
        internal_scope.form_submit[common_form_date.id] = new_date
      }

      country_field = _.find(
        internal_scope.form.fields,
        (field) =>
          field.form_type == 'common' && field.ehr_attr_name == 'country'
      )
      if (country_field) {
        usa =
          _.find(country_field.options, (opt) => {
            return opt.label == 'USA'
          }) || country_field.options[0]
        internal_scope.form_submit[country_field.id] = usa.id
      }

      this.setPaymentsForm(internal_scope)
      this.setTabIndexes(internal_scope)
      this.startFormWatch(internal_scope)
      this.startKeyPressWatch(internal_scope)
    }

    this.setUpStripeElement = (internal_scope) => {
      if (!window.Stripe) return
      const location_id = _.get($rootScope, ['location', 'id'])
      const locationName = _.get($rootScope, ['location', 'name'])
      const institution_id = _.get($rootScope, ['location', 'institution_id'])
      $api(
        'GET',
        `/finance/configuration?institution_id=${institution_id}&location_id=${location_id}`
      )
        .finally(() => {
          internal_scope.payment_loading = false
        })
        .then((result) => {
          if (
            result &&
            result.data &&
            result.data.data &&
            result.data.data.publishable_key
          ) {
            const stripe = window.Stripe(result.data.data.publishable_key)
            const elements = stripe.elements({
              mode: 'setup',
              currency: 'usd',
            })
            let options = {
              // Use readOnly since this is a preview
              readOnly: true,
            }
            const businessName = locationName || undefined
            if (businessName) {
              options = Object.assign(options, {
                business: {
                  name: businessName,
                },
              })
            }
            const element = elements.create('payment', options)

            stripeDropInElement = document.createElement('div')
            stripeDropInElement.id =
              internal_scope.stripe_dropin || 'stripe-dropin'
            stripeWrapperElement = document.getElementById(
              internal_scope.stripe_wrapper || 'stripe-drop-in-wrapper'
            )
            if (!stripeWrapperElement) return
            stripeWrapperElement.appendChild(stripeDropInElement)
            element.mount(`#${stripeDropInElement.id}`)
          }
        })
    }

    this.setPaymentsForm = (internal_scope) => {
      if (!internal_scope.form || !internal_scope.form.fields) { return }

      payments_field = _.find(internal_scope.form.fields, (field) => {
        return field.field_type == 'payments'
      })
      if (!payments_field) { return }

      internal_scope.payment_loading = true
      opts = { institution_id: $rootScope.institution.id }
      if ($rootScope.location) {
        opts['location_id'] = $rootScope.location.id
      }
      this.setUpStripeElement(internal_scope)
    }

    this.setTabIndexes = (internal_scope) => {
      field_index = 0
      _.each(internal_scope.form.fields, (field) => {
        field_index = field_index + 1
        field.tabindex = field_index
        if (field.field_type == 'boolean') {
          field_index = field_index + 1
        }
        _.each(field.options, (option) => {
          field_index = field_index + 1
          option.tabindex = field_index
        })
      })
    }

    this.autoFillPatientsData = (internal_scope) => {
      _.each(internal_scope.form.fields, (field) => {
        if (
          field.options &&
          field.options.length &&
          _.includes(_.map(field.options, 'user_attr_name'), 'unsubscribe_sms')
        ) {
          unsubscribe_field = true
        } else {
          unsubscribe_field = false
        }
        if (
          internal_scope.user_id &&
          field.responses &&
          field.responses.length &&
          field.responses[0].values
        ) {
          // Individual URL Form
          response_value = field.responses[0].values
          if (field.field_type == 'date' && response_value) {
            if (internal_scope.is_mobile) {
              new_date = new Date(response_value)
            } else { // text input
              new_date = moment(response_value)
              new_date = this.dateFormat(new_date, 'MM/DD/YYYY')
            }
            response_value = new_date
          }
          internal_scope.form_submit[field.id] = response_value
          if (!unsubscribe_field) {
            // deny existing fields editing (except the subscriptions settings)
            field.non_editable = true
          }
        } else if (!internal_scope.user_id && unsubscribe_field) {
          // Common URL Form
          // enable 'Text Me'/ 'Email Me' by default
          internal_scope.form_submit[field.id] = _.map(field.options, 'id')
        }
      })
    }

    this.toggleChildFields = (internal_scope) => {
      fields_with_children = _.filter(
        this.fieldsBySection(internal_scope),
        (field) => {
          return field.with_child_fields
        }
      )

      _.each(fields_with_children, (field) => {
        this.toggleChildField(internal_scope, field)
      })
    }

    this.toggleChildField = (internal_scope, field) => {
      if (!field.with_child_fields) {
        return false
      }

      // show/hide child fields on select a parent's field value
      child_fields = _.filter(internal_scope.form.fields, (field) => {
        return field.parent_field_id == field.id
      })
      child_fields_html = $('.parent_field_id_' + field.id)
      if (internal_scope.form_submit[field.id]) {
        child_fields_html.fadeIn('fast', function () {
          $(this).removeClass('hidden')
        })
        if (
          child_fields_html.parent()[0] &&
          child_fields_html.parent()[0].className != 'child-fields'
        ) {
          child_fields_html.wrapAll('<div class="child-fields"></div>')
        }
      } else {
        child_fields_html.fadeOut('fast', function () {
          $(this).addClass('hidden')
        })
      }
    }

    this.fieldsBySection = (internal_scope, section = internal_scope.currentTab) => {
      if (!section) { return internal_scope.form.fields }

      fields = internal_scope.form.fields

      if (internal_scope.form.form_type == 'online_booking') { return fields }

      fields = _.filter(fields, (field) => {
        return field.form_section == section.name
      })

      // Returns identifiable fields for filtered sections or groups
      if (internal_scope.isFilteredForm &&
          internal_scope.filterType == 'section' &&
          ['child_information', 'personal_info'].includes(section.name)) {

        // Adds extra identifiable fields to the personal or child information
        if (['child_information', 'personal_info'].includes(internal_scope.filterId)) {
          _.each(internal_scope.form.identifiable_fields, (field) => {
            if (!_.find(fields, (f_array) => { return (f_array.id == field.id) })) {
              fields.push(field)
            }

          })
          return fields
        } else {
          return internal_scope.form.identifiable_fields
        }
      }

      return fields
    }

    this.dateFormat = (date, date_format = 'YYYY-MM-DD') => {
      // set date to the required format
      // the default one is for HTML5 input type='date'
      if (!date) {
        return null
      }

      converted_date = datesInTimezone.convertFromUserToLocTimezone(date, false)
      if (converted_date) {
        date = converted_date.format(date_format)
      }
      return date
    }

    this.toggleBoolean = (internal_scope, field, opt) => {
      if (internal_scope.form_submitting || field.non_editable) {
        return
      }

      internal_scope.form_submit[field.id] = opt.value
      this.toggleChildField(internal_scope, field)
    }

    this.toggleOption = (internal_scope, field, opt) => {
      if (internal_scope.form_submitting || field.non_editable) {
        return
      }

      field_submitted = internal_scope.form_submit[field.id] || []
      if (field_submitted.indexOf(opt.id) == -1) {
        if (field.field_type == 'checkbox') {
          field_submitted.push(opt.id)
        } else {
          field_submitted = [opt.id]
        }
      } else {
        _.remove(field_submitted, (v) => v == opt.id)
      }
      internal_scope.form_submit[field.id] = field_submitted
      this.toggleChildField(internal_scope, field)
    }

    this.optionIsChecked = (internal_scope, field, option) => {
      return (
        internal_scope.form_submit[field.id] &&
        internal_scope.form_submit[field.id].indexOf(option.id) != -1
      )
    }

    this.toggleFormPolicy = (internal_scope, event, doc_id, on_keypress = false) => {
      if (!on_keypress || event.keyCode == 13 || event.which == 13) {
        // on click and on press 'Enter' key
        if (!internal_scope.form_submit.documents) {
          internal_scope.form_submit.documents = {}
        }
        if (internal_scope.form_submit.documents[doc_id]) {
          delete internal_scope.form_submit.documents[doc_id]
        } else {
          internal_scope.form_submit.documents[doc_id] = true
        }
      }
    }

    this.goToStep = (internal_scope, step_num, next = false) => {
      if (internal_scope.form_submitting) {
        return
      }
      if (
        (step_num || step_num == 0) &&
        step_num == internal_scope.activePill
      ) {
        return
      } // same step
      if (step_num && step_num > internal_scope.maxStepSubmitted + 1) {
        // deny going forward to more then 1 step from the previous max step submitted
        return
      }
      is_step_forward =
        (step_num && step_num > internal_scope.activePill) || next
      if (
        internal_scope.currentTab &&
        !internal_scope.form_valid &&
        is_step_forward
      ) {
        return
      }

      internal_scope.errors = []

      internal_scope.defered_existing_responses = $q.defer()
      internal_scope.defered_existing_responses.promise.then(() => {
        if (step_num || step_num == 0) {
          internal_scope.activePill = step_num
        } else if (next) {
          internal_scope.activePill = internal_scope.activePill + 1
        } else if (internal_scope.activePill) {
          internal_scope.activePill = internal_scope.activePill - 1
        }
        this.setCurrentTab(internal_scope, is_step_forward)
        this.validateForm(internal_scope)
        $window.scrollTo(0, 0)
        this.toggleChildFields(internal_scope)
        this.focusOnFirstField(internal_scope)
      })

      if (is_step_forward) {
        perform_checkings = true
      } else {
        perform_checkings = false
      }
      this.checkNoResponsesForCommonForm(internal_scope, perform_checkings)
    }

    this.setCurrentTab = (internal_scope, is_step_forward = false) => {
      if (is_step_forward) {
        if (internal_scope.currentTab) {
          internal_scope.maxStepSubmitted = _.max([
            internal_scope.maxStepSubmitted,
            internal_scope.currentTab.index,
          ])
        } else {
          internal_scope.maxStepSubmitted = 0
        }
      }
      internal_scope.currentTab = _.find(
        internal_scope.form_tabs,
        (tab) => tab.index == internal_scope.activePill
      )
      if(internal_scope.currentTab) {
        internal_scope.currentTab.visited = true
      }
    }

    this.startFormWatch = (internal_scope) => {
      internal_scope.$watch(
        'form_submit',
        (nv, ov) => {
          this.validateForm(internal_scope)
        },
        true
      )
    }

    this.startKeyPressWatch = (internal_scope) => {
      // focus on next HTML element by pressing Tab on desktop and Enter on mobile
      $(document).on('keydown', 'input, select', (e) => {
        if (
          (internal_scope.is_mobile && (e.which == 13 || e.keyCode == 13)) ||
          e.which == 9 ||
          e.keyCode == 9
        ) {
          e.preventDefault()
          e.stopPropagation()
          var focussable_fields = $(
            '.ne__fieldset__group :tabbable:visible:not(:disabled):not([readonly])'
          )
          var idx = focussable_fields.index(e.currentTarget)
          if (idx == focussable_fields.length - 1) {
            var buttons = $(
              '.ne__btn__group :tabbable:visible:not(:disabled):not([readonly])'
            )
            if (buttons[0]) {
              buttons[0].focus()
            }
          } else {
            focussable_fields[idx + 1].focus()
          }
        }
      })
    }

    this.focusOnFirstField = (internal_scope) => {
      if (internal_scope.preview) { return }

      $timeout(() => {
        first_visible_field = $('.ne__fieldset__group :tabbable:visible')[0]
        if (first_visible_field) {
          first_visible_field.focus()
        }
      }, 100)
    }

    this.validateForm = (internal_scope) => {
      valid = true
      _.each(this.fieldsBySection(internal_scope), (field) => {
        if (
          field.is_required &&
          field.field_type != 'payments' &&
          this.isFieldValueEmpty(internal_scope, field.id)
        ) {
          valid = false
        }
        // check SSN pattern
        if (
          field.ehr_attr_name == 'ssn' &&
          !this.isFieldValueEmpty(internal_scope, field.id)
        ) {
          ssn_regex = new RegExp(internal_scope.ssn_pattern, 'g')
          if (!internal_scope.form_submit[field.id].match(ssn_regex)) {
            valid = false
          }
        }
        // check if date has a valid format (for text input only - not on mobile)
        if (field.field_type == 'date' &&
           !internal_scope.is_mobile &&
           !this.isFieldValueEmpty(internal_scope, field.id) &&
           !moment(_.clone(internal_scope.form_submit[field.id]), 'MM/DD/YYYY', true).isValid()) {
          valid = false
        }
      })
      // check signatures for an each policy on last step
      if (internal_scope.activePill >= internal_scope.form_tabs.length - 1) {
        _.each(internal_scope.form.documents, (doc) => {
          if (this.isFieldValueEmpty(internal_scope, doc.id, 'documents')) {
            valid = false
          }
        })
      }
      internal_scope.form_valid = valid
    }

    this.isFieldValueEmpty = (internal_scope, field_id, child_model) => {
      if (child_model) {
        form_field =
          internal_scope.form_submit[child_model] &&
          internal_scope.form_submit[child_model][field_id]
      } else {
        form_field = internal_scope.form_submit[field_id]
      }

      return (
        typeof form_field == 'undefined' ||
        angular.equals(form_field, []) ||
        angular.equals(form_field, {}) ||
        _.includes(['', null, undefined], form_field)
      )
    }

    this.checkNoResponsesForCommonForm = (internal_scope, perform_checkings = false) => {
      if (internal_scope.user_id || !perform_checkings) {
        // individual form or going to the previous step
        internal_scope.defered_existing_responses.resolve(true)
        return
      }

      ssn_field = _.filter(this.fieldsBySection(internal_scope), (field) => {
        return field.ehr_attr_name == 'ssn'
      })[0]
      if (!ssn_field) {
        // step without the SSN field
        this.checkNoResponsesForCommonFormByUser(internal_scope)
        return
      } else {
        ssn_field_value = internal_scope.form_submit[ssn_field.id]
      }

      if (!ssn_field_value) {
        // the SSN is not filled in
        this.checkNoResponsesForCommonFormByUser(internal_scope)
        return
      }

      internal_scope.form_submitting = true
      ssn_params = {
        form_id: internal_scope.form.id,
        check_responses_by_ssn: ssn_field_value,
      }

      form_responses = FormResponseCheckExisting.$search(ssn_params)
      form_responses.$finally(() => {
        internal_scope.form_submitting = false
        if (form_responses.$response.data.code) {
          internal_scope.errors = []
          this.checkNoResponsesForCommonFormByUser(internal_scope)
        } else {
          this.setErrors(internal_scope, form_responses)
        }
      })
    }

    this.checkNoResponsesForCommonFormByUser = (internal_scope) => {
      user_field_phones = ["bio['phone_number']", "bio['home_phone_number']", "bio['work_phone_number']"]
      any_user_field = _.filter(this.fieldsBySection(internal_scope), (field) => {
        return _.includes(user_field_phones, field.user_attr_name)
      })[0]
      if (!any_user_field) {
        // step without the Phone field
        internal_scope.defered_existing_responses.resolve(true)
        return
      }

      internal_scope.form_submitting = true
      fields = this.formFields(internal_scope)
      user_field_names = [
        "bio['phone_number']",
        "bio['home_phone_number']",
        "bio['work_phone_number']",
        'first_name',
        'last_name',
        'email',
      ]
      user_fields = _.filter(fields, (field) => {
        return _.includes(user_field_names, field.user_attr_name)
      })
      user_params = {
        'fields[]': user_fields,
        form_id: internal_scope.form.id,
        user_id: internal_scope.user_id,
        check_responses_by_user: true,
      }

      form_responses = FormResponseCheckExisting.$search(user_params)
      form_responses.$finally(() => {
        internal_scope.form_submitting = false
        if (form_responses.$response.data.code) {
          internal_scope.errors = []
          internal_scope.defered_existing_responses.resolve(true)
        } else {
          this.setErrors(internal_scope, form_responses)
        }
      })
    }

    this.formSubmit = (internal_scope) => {
      internal_scope.form_submitting = true
      form_response = FormResponse.$new()
      form_response.fields = this.formFields(internal_scope)
      form_response.form_id = internal_scope.form.id
      form_response.user_id = internal_scope.user_id
      form_response.form_sections = _.map(internal_scope.form_tabs, tab => { return tab.name })
      form_response.$save().$finally(() => {
        internal_scope.form_submitting = false
        if (form_response.$response.data.code) {
          internal_scope.errors = []
          $state.go('patient_form_thank_you')
        } else {
          this.setErrors(internal_scope, form_response)
        }
      })
    }

    this.formFields = (internal_scope) => {
      fields = []
      _.each(internal_scope.form_submit, (values, key) => {
        field = _.find(internal_scope.form.fields, (field) => field.id == key)
        if (!field) {
          return
        }

        res = {
          'ehr_attr_name': field.ehr_attr_name,
          'user_attr_name': field.user_attr_name,
        }

        if (field.field_type == 'checkbox') {
          _.each(values, (value) => {
            fields.push(
              _.extend({}, res, { 'form_field_id': key, 'form_option_id': value })
            )
          })
        } else {
          if (angular.isArray(values)) {
            values = values[0]
          }
          res['form_field_id'] = key
          switch (field.field_type) {
            case 'boolean':
              res['response_boolean'] = values
              break
            case 'radio':
            case 'dropdown_list':
              res['form_option_id'] = values
              break
            case 'date':
              res['response_body'] = this.dateFormat(values, 'YYYY-MM-DD')
              break
            default:
              if (!_.isEmpty(_.trim(values))) {
                res['response_body'] = encodeURIComponent(values)
              }
          }
          fields.push(res)
        }
      })
      return fields
    }

    this.setErrors = (internal_scope, obj) => {
      if (obj.$response.error && obj.$response.error[0]) {
        internal_scope.errors = obj.$response.error
      } else {
        internal_scope.errors = obj.$response.data.error
      }
    }

    this.start = (internal_scope, form_id, preview = false, payments_appt_booking = false, filterType, filterId) => {
      internal_scope.form_id = form_id
      internal_scope.filterType = filterType
      internal_scope.filterId = filterId
      internal_scope.remember_token = $stateParams.rememberToken
      internal_scope.form_loading = true
      internal_scope.other_tab_name = 'Other'
      internal_scope.ssn_pattern = '^[0-9]{3}-?[0-9]{2}-?[0-9]{4}$'
      internal_scope.is_mobile = browser.mobile
      internal_scope.preview = preview
      internal_scope.payments_appt_booking = payments_appt_booking

      if (preview) {
        internal_scope.form = internal_scope.preview_form
        this.setupForm(internal_scope)
        internal_scope.errors = []
        internal_scope.form_loading = false
      } else {
        this.formGet(internal_scope)
      }
    }

    return this
  }
])
